export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/util/eventConsts.js
// module id = 690
// module chunks = 1